import React, { useEffect, useState } from "react";
import CreateProperty from "./CreateProperty";
import { useParams } from "react-router-dom";

import { useSelector } from "react-redux";

const EditProperty = () => {
  const { villas } = useSelector((state) => state.villas);
  const { id } = useParams();

  return <CreateProperty {...{ property: villas.find((v) => v.id === +id) }} />;
};

export default EditProperty;
